<template>
  <div>
    <div class="hearder-title">
      <div class="flex_between">
        <img class="title-icon" src="@/assets/img/title-icon.svg" alt="dark" />
        <span v-if="claimStatementAudit.auditType === '责任判定'"
          >判责信息</span
        >
        <span v-else-if="claimStatementAudit.auditType === '责任确认'"
          >责任确认信息</span
        >
        <span v-else-if="claimStatementAudit.auditType === '责任金额'"
          >责任金额信息</span
        >
        <span v-else-if="claimStatementAudit.auditType === '金额确认'"
          >金额确认信息</span
        >
        <span v-else-if="claimStatementAudit.auditType === '结算'"
          >结算信息</span
        >
        <span v-else>审核信息</span>
      </div>
    </div>
    <div class="form-container">
      <!-- 流程环节 -->
      <el-form-item
        v-if="
          !(
            claimStatementAudit.auditType === '责任判定' ||
            claimStatementAudit.auditType === '责任确认' ||
            claimStatementAudit.auditType === '责任金额' ||
            claimStatementAudit.auditType === '金额确认' ||
            claimStatementAudit.auditType === '结算'
          )
        "
        :label="
          String(claimStatementAudit.auditType).indexOf('审') != -1
            ? '审核环节'
            : '流程环节'
        "
      >
        <el-input disabled v-model="claimStatementAudit.auditType" />
      </el-form-item>
      <!-- 流程结果 -->
      <el-form-item
        v-if="
          !(
            claimStatementAudit.auditType === '责任金额' ||
            claimStatementAudit.auditType === '结算'
          )
        "
        :label="
          String(claimStatementAudit.auditType).indexOf('审') != -1
            ? '审核结果'
            : '流程结果'
        "
      >
        <el-input disabled v-model="claimStatementAudit.status"></el-input>
      </el-form-item>
      <!-- 驳回原因 -->
      <el-form-item
        v-if="claimStatementAudit.remarkzh"
        :label="
          String(claimStatementAudit.status).indexOf('驳回') != -1 ? '驳回原因' : '原因'
        "
      >
        <el-input disabled v-model="claimStatementAudit.remarkzh"></el-input>
      </el-form-item>
      <!-- 操作人员 -->
      <el-form-item
        :label="
          String(claimStatementAudit.auditType).indexOf('审') != -1
            ? '审核人员'
            : '操作人员'
        "
      >
        <el-input disabled v-model="claimStatementAudit.staffName"></el-input>
      </el-form-item>
      <!-- 操作时间 -->
      <el-form-item
        :label="
          String(claimStatementAudit.auditType).indexOf('审') != -1
            ? '审核时间'
            : '操作时间'
        "
      >
        <el-input disabled v-model="claimStatementAudit.createTime"></el-input>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    claimant: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      claimStatementAudit: {}
    };
  },
  created() {
    this.claimStatementAudit = JSON.parse(
      JSON.stringify(this.claimant.claimStatementAudit)
    );
    if (this.claimant?.claimStatementAudit?.auditType === 0) {
      this.claimStatementAudit.auditType = "预审";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 1) {
      this.claimStatementAudit.auditType = "正审";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 2) {
      this.claimStatementAudit.auditType = "责任判定";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 3) {
      this.claimStatementAudit.auditType = "责任确认";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 4) {
      this.claimStatementAudit.auditType = "金额确认";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 5) {
      this.claimStatementAudit.auditType = "提交";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 6) {
      this.claimStatementAudit.auditType = "结算";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 7) {
      this.claimStatementAudit.auditType = "取消";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 8) {
      this.claimStatementAudit.auditType = "撤回";
    }
    if (this.claimant?.claimStatementAudit?.auditType === 9) {
      this.claimStatementAudit.auditType = "责任金额";
    }
    if (this.claimant?.claimStatementAudit?.status === 1) {
      this.claimStatementAudit.status = "通过";
    }
    if (this.claimant?.claimStatementAudit?.status === 2) {
      this.claimStatementAudit.status = "不同意";
    }
    if (this.claimant?.claimStatementAudit?.status === 3) {
      this.claimStatementAudit.status = "驳回";
    }
    if (this.claimant?.claimStatementAudit?.status === 4) {
      this.claimStatementAudit.status = "拒赔";
    }
  }
};
</script>

<style lang="scss" scoped>
.hearder-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #333333;
  padding: 14px 10px 14px 20px;
  border-bottom: 1px solid #dcdee0;
  .title-icon {
    margin-right: 10px;
  }
  p {
    font-size: 16px;
    color: #4095e5;
    font-weight: bold;
    i {
      font-size: 18px;
      color: #4095e5;
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.form-container {
  margin-top: 34px;
  // padding: 0 60px;
}
</style>
